export const ClientApiValidation = (formData) => {
    const errors = {};
    debugger;
    // Validate each field
    if (!formData.ClientID.toString().trim()) {
      errors.ClientID = 'This field is required';
    } 
    if (!formData.BaseURL.trim()) {
        errors.BaseURL = 'This field is required';
      } 
  
    return errors;
  };
  
 